var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full rounded-full bg-grey-200"},[_c('div',{staticClass:"h-10 rounded-full",class:{
      'md:h-20': !_vm.small,
      'orange-gradient': _vm.gradient,
      'bg-green-500': !_vm.gradient,
    },style:(`width: ${_vm.clampedPercentage}%`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }